import React from 'react';
import { connect } from "react-redux";
import { pageChange } from '../../action/view';
import AddChartForm from './AddChartForm';

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = {
    pageChange
};

class Chart extends React.Component {
    render() {
        return (
            <div className="AddSurvey">
                <AddChartForm/>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Chart);
